import { Tag } from "lucide-react";

const money = (n) => `$${Number(n || 0).toFixed(2)}`;
const until = (iso) => {
    if (!iso) return "";
    try { return new Date(iso).toLocaleDateString([], { month: "short", day: "numeric" }); }
    catch { return ""; }
};

/** The shop marked this down. Same red ticket everywhere it shows. */
export function SaleTag({ sale, className = "", testid }) {
    if (!sale?.percent) return null;
    return (
        <span data-testid={testid}
            className={`inline-flex items-center gap-1 rounded-full border border-red-700/30 bg-red-50 px-2.5 py-1 font-mono text-[11px] font-bold uppercase tracking-[0.14em] text-red-800 ${className}`}>
            <Tag size={9} /> {Math.round(sale.percent)}% off
        </span>
    );
}

export function SalePrice({ sale, price, prefix = "from", className = "", testid }) {
    const full = Number(price || 0);
    if (!sale?.percent || !full) return null;
    const now = sale.now != null ? sale.now : full * (1 - sale.percent / 100);
    return (
        <span className={`inline-flex flex-wrap items-baseline gap-1.5 ${className}`} data-testid={testid}>
            <span className="font-mono text-sm font-bold text-red-800">{prefix} {money(now)}</span>
            <s className="font-mono text-xs text-zinc-500">{money(full)}</s>
        </span>
    );
}

/** In the designers, next to the live total. */
export function SaleChip({ sale, className = "", testid }) {
    if (!sale?.percent) return null;
    return (
        <p data-testid={testid}
            className={`inline-flex flex-wrap items-center gap-x-2 gap-y-0.5 rounded-lg border border-red-700/25 bg-red-50 px-2.5 py-1.5 text-[11px] text-red-900 ${className}`}>
            <span className="font-mono text-[11px] font-bold uppercase tracking-[0.14em]">
                sale · {Math.round(sale.percent)}% off
            </span>
            {sale.was_total != null && <s className="text-red-900/60">was {money(sale.was_total)}</s>}
            {sale.title && <span className="font-semibold">{sale.title}</span>}
            {sale.ends_at && <span className="text-red-900/70">through {until(sale.ends_at)}</span>}
        </p>
    );
}

/** The banner across a shop's own page while a sale is running. */
export function SaleStrip({ sales, className = "", testid = "store-sales" }) {
    if (!sales?.length) return null;
    return (
        <div className={`flex flex-wrap gap-2 ${className}`} data-testid={testid}>
            {sales.map((s, i) => (
                <span key={i} data-testid={`store-sale-${i}`}
                    className="inline-flex flex-wrap items-center gap-2 rounded-lg border border-red-700/30 bg-red-50 px-3 py-2 text-sm text-red-900">
                    <span className="inline-flex items-center gap-1 font-mono text-[11px] font-bold uppercase tracking-[0.16em]">
                        <Tag size={11} /> {Math.round(s.percent)}% off
                    </span>
                    <span className="font-semibold">{s.title}</span>
                    <span className="text-red-900/75">{s.covers_label}</span>
                    {s.ends_at && <span className="font-mono text-[11px] uppercase tracking-[0.12em] text-red-900/70">through {until(s.ends_at)}</span>}
                </span>
            ))}
        </div>
    );
}
